
    import {groupInstrumentByType, groupInstrumentByCity,groupInstrumentCountByType, groupInstrumentCountByCity} from "../../js/instrumentType/instrumentType";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import echarts from "echarts";
    import {instrumentAll} from "@/js/referenceMaterial/referenceMaterial";
    @Component({
        name: "Approval_Index",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = '';
        mode = '0' //0 按器具分类统计  1 生产企业地区分布情况统计
        resultList = [] as any;
        tableList = [] as any;
        pageIndex = 0;
        pageSize = 10;
        totalCount = 0;
        modal = {
            visible: false,
        }
        listTotal = 0;
        showForm = false;
        instrumentTypes = [
          {name: '新建科研项目', id: 1},
          {name: '储备科研项目', id: 2},
          {name: '在研科研项目', id: 3},
          {name: '结题科研项目', id: 4}
        ];
        propParams = {
            city_name: "",
            instr_type: "",
            instr_name: "",
            org_name: "",
          start: '',
          end: ''
        }
        myChart = null as any;
        fullScreen = false;

      // 增删改
      editId = '';
      editDialog = false;
      addform = {
        name: "",  //机房号
        times: "",    //巡检时间
        range: "",    //巡检范围
        user: "",    //巡检人
        note: "",    //备注
      } as any

        mounted() {
          this.jumpPage(1);
        }

        indexMethod(index: any) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        }
        doLayout(el: any){
           const e = this.$refs[el] as any;
            if(e){
                e.doLayout() // 解决表格错位
            }
        }
        pageSizeChange(val: number) {
            this.pageSize = val;
            this.jumpPage(this.pageIndex);
        }
        refresh(){
            this.jumpPage(1);
        }
        reset(){
            this.propParams.instr_name = '';
            this.propParams.start = '';
            this.propParams.end = '';
            this.propParams.org_name = '';
            this.refresh();
        }
        jumpPage(val: any){
            let resultList = JSON.parse(JSON.stringify(this.resultList));
            const {instr_name, instr_type, city_name, org_name} = this.propParams;
            if(instr_name != ''){
                resultList = resultList.filter((r: any) => r.instr_name.indexOf(instr_name) > -1);
            }
            if(instr_type != ''){
                resultList = resultList.filter((r: any) => r.instr_type == instr_type);
            }
            if(city_name != ''){
                resultList = resultList.filter((r: any) => r.city_name.indexOf(city_name) > -1);
            }
            if(org_name != ''){
                resultList = resultList.filter((r: any) => r.org_name.indexOf(org_name) > -1);
            }
            const tableList = resultList;
            this.totalCount = resultList.length;
            this.pageIndex = val;
            const pageIndex = val;
            const pageSize = this.pageSize;
            const totalCount = tableList.length;
            const start = (pageIndex - 1) * pageSize;
            const end = pageIndex * pageSize > totalCount ? totalCount : pageIndex * pageSize;
          // this.tableList = tableList.slice(start, end);
          this.tableList = [
            {name: '103', times: '2023-11-16', range: '1-5号机柜', user: '张三', note: '一切正常'}
          ]
          this.totalCount = 1;
        }

      // 增删改
      add() {
        this.addform = {
          name: "",  //项目名称
          status: "",    //项目类型
          times: "",    //时间
          user: "",    //负责人
        }
        this.editDialog = true;
        this.editId = '';
      }
      saveBtn() {
        if (this.editId) {
          this.$set(this.tableList,this.editId,this.addform);
        } else {
          const form = Object.assign({}, this.addform, {id: this.tableList.length});
          this.tableList.push(form);
        }
        this.editDialog = false;
        this.totalCount = this.tableList.length;
      }
      del(index: number) {
        this.$confirm('确定要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableList.splice(index, 1);
          this.totalCount = this.tableList.length;
        })
      }
      edit(index: number) {
        this.editId = String(index);
        this.addform = JSON.parse(JSON.stringify(this.tableList[index]));
        this.editDialog = true;
      }
    }
